<template>
  <div>
   
    <div class="row">
      <div class="col-md-12 text-center">
        <h4 class="purple">{{$t('marketingCampaigns.campaignDetails')}}</h4>
      </div>
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.name')}}</label>
          <input type="text"
                 name="name"
                 :placeholder="$t('marketingCampaigns.name')" 
                 v-validate="modelValidations.name"
                 v-model="model.name"
                 class="form-control">
          <small class="text-danger" v-if="errors.name">
            {{ getError('name') }}
          </small>
        </div>
      </div>
      <div class="col-md-4 col-md-offset-1">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.image')}}</label>
          <el-upload
            action=""
            ref="upload"
            :limit="2"
            :file-list="model.imagelist"
            list-type="picture-card"
            accept=" .jpg, .jpeg, .png"
            :on-change="handleImgChnage"
            :on-exceed="handleExceed"
            :on-remove="handleRemove"
            :auto-upload="false">
            <i class="el-icon-plus"></i>
            <div class="el-upload__tip" slot="tip">{{$t('validations.pictureSize')}}</div>
          </el-upload>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.description')}} <small>{{$t('marketingCampaigns.maxDescription')}}</small></label>
          <textarea name="description" rows="6"
                 :placeholder="$t('marketingCampaigns.description')" 
                 v-model="model.description"
                 v-validate="modelValidations.description"
                 class="form-control"></textarea>
          <div><small class="pull-right">{{model.description ? model.description.length : '0'}} {{$t('marketingCampaigns.characters')}}</small></div>
          <small class="text-danger" v-if="errors.description">
            {{ getError('description') }}
          </small>
        </div>
      </div>
      <div class="col-md-10 col-md-offset-1">
        <div class="form-group">
          <label>{{$t('marketingCampaigns.validFromTo')}}</label>
          <br/>
          <el-date-picker type="daterange" v-model="model.fromto"
                              :name="pickerNames"
                              :picker-options="pickerOptions1">
          </el-date-picker>
          <small class="text-danger" v-if="errors.date_from">
            {{ getError('date_from') }}
          </small>
        </div>
      </div>     
    </div>
  </div>
</template>
<script>
  // import Vue from 'vue'
  import {mapFields} from 'vee-validate'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  export default {
    props: {
      modelFromParent: {
        type: [Object, Array],
        required: true
      }
    },
    watch: {
      modelFromParent (value, oldVal) {
        this.model = value
      }
    },
    computed: {
      ...mapFields(['name'])
    },
    data () {
      return {
        date: {
          trends: {
            'valid': [
              '2018-01-01',
              '2018-12-31'
            ]
          }
        },
        model: this.value || this.modelFromParent,
        modelValidations: {
          name: {
            required: true
          },
          description: {
            max: 255
          }
        },
        couponType: this.$session.get('defaultData')['coupons_types'],
        couponUsageTypes: this.$session.get('defaultData')['coupons_usage_types'],
        pickerOptions1: {},
        pickerNames: ['date_from', 'date_to'],
        desclength: 0
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        return this.$validator.validateAll()
        // this.$validator.validateAll().then(isValid => {
        //   // this.$emit('on-submit', this.registerForm, isValid)
        //   return isValid
        // })
      },
      handleImgChnage (file, fileList) {
        // console.warn('handleImgChnage')
        // const isJPG = file.type === 'image/jpeg'
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            text: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
          this.$refs.upload.clearFiles()
          this.model.imagelist = []
        } else {
          if (fileList.length > 1) {
            this.model.imagelist = fileList.slice(1)
          } else {
            this.model.imagelist = fileList
          }
        }
      },
      handleRemove (file, fileList) {
        console.log('handleRemove')
        if (fileList.length === 0) {
          this.model.imagelist = []
        }
      },
      uploadImage (upload) {
      },
      handleExceed (files, fileList) {
        swal({
          text: this.$t('validations.removePhoto'),
          type: 'warning',
          showConfirmButton: true
        })
      },
      beforeUpload (file) {
        const isOkSize = file.size / 1024 / 1024 < 5
        var self = this
        if (!isOkSize) {
          swal({
            toast: true,
            type: 'warning',
            title: self.$t('validations.pictureSizeExceed'),
            position: 'top-end',
            showConfirmButton: false,
            timer: 3000
          })
        }
        return isOkSize
      }
    }
  }
</script>
<style>
  .el-upload--picture-card{
    width: 48px;
    height: 48px;
    line-height: 61px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Campaigns/Steps/FirstStep.vue